<template>
  <div :class="device.isMobile ? 'py-2' : 'px-4 pb-2'">
    <v-overlay v-if="loading.loadNonContract" :absolute="true">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-data-table
      :search="filters.search"
      :headers="getMobileHeaders(headers)"
      :items="noContractDelivery"
      class="table-striped ordera-box-shadow"
      hide-default-footer
      mobile-breakpoint="0"
      disable-pagination
      :loading="loading.loadNonContract"
    >
      <template v-slot:item.num="{ item, index }">
        {{ item.name !== $t("total") ? index + 1 : "" }}
      </template>
      <template v-slot:item.time="{ item }">
        <template v-if="item.name === $t('total')">{{ $t("total") }}</template>
        <template v-else v-for="(meal, index) in item.order_guest_transactions">
          <template v-if="index == 0">
            <span>{{ meal.date }}</span>
          </template>
        </template>
      </template>
      <template v-slot:item.name="{ item }">
        <template v-for="meal in item.order_guest_transactions">
          <span :title="'ID: ' + meal.id">{{ translate(meal.meals.name) }}</span>
          <br />
        </template>
      </template>
      <template v-slot:item.price="{ item }">
        <template v-for="meal in item.order_guest_transactions">
          <template>
            {{ meal.price }}
          </template>
          <br />
        </template>
      </template>
      <template v-slot:item.quantity="{ item }">
        <template v-if="item.quantity">
          {{ item.quantity }}
        </template>
        <template v-else v-for="meal in item.order_guest_transactions">
          <template>
            {{ meal.quantity }}
          </template>
          <br />
        </template>
      </template>
      <template v-slot:item.qty="{ item }">
        <template v-if="item.qty">
          {{ item.qty }}
        </template>
        <template v-else>
          {{ priceDelivery(item.order_guest_transactions) }}
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import reportService from "@/services/report";
import hasMobileHeaders from "@/mixins/report/hasMobileHeaders";

export default {
  mixins: [hasMobileHeaders],
  data: () => ({
    noContract: [],
    loading: {
      loadNonContract: false,
    },
  }),
  methods: {
    async loadNonContract() {
      if (this.loading.loadNonContract) {
        console.warn(
          "Load non-contract operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.loading.loadNonContract = true;

      const params = {
        date: this.filters.dates.from,
        date2: this.filters.dates.to,
      };

      try {
        const res = await reportService.getNoContractDelivery(
          this.$store.state.restaurant.id,
          params
        );

        this.noContract = res.data;
        for (let i in res.data) {
          if (res.data[i].length) {
            res.data[i].filter((order) => {
              order.orders_guest.filter((o) => {
                o.order_guest_transactions.filter((ord) => {
                  mealFood.push(ord);
                });
              });
              order.orders = mealFood;
            });
          }
        }
      } catch (error) {
        console.error("Error loading non-contract delivery:", error);
      } finally {
        this.loading.loadNonContract = false;
      }
    },

    priceDelivery(meals) {
      let price = 0;
      if (meals) {
        meals.filter((meal) => {
          price += meal.quantity * meal.price;
        });
      }
      return price;
    },
  },
  computed: {
    noContractDelivery() {
      let test = [];
      let meals = [];
      for (let i in this.noContract) {
        if (i == "IsporukaZaNeregistrovane") {
          this.noContract[i][0].orders_guest.filter((meal) => {
            test.push(meal);
            meal.order_guest_transactions.filter((food) => {
              food.date = meal.date + " | " + meal.delivery_time;
              meals.push(food);
            });
          });
        }
      }
      let qty = 0;
      let pr = 0;
      test.filter((itm) => {
        itm.order_guest_transactions.filter((q) => {
          qty += q.quantity;
          pr += q.price * q.quantity;
        });
      });
      test.push({
        name: this.$t("total"),
        price: "",
        quantity: qty,
        qty: pr,
      });
      return test;
    },
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", align: "start" },
        { text: this.$t("id_order"), value: "id", align: "start" },
        { text: this.$t("delivery_time"), value: "time", align: "start" },
        { text: this.$t("meal_meal"), value: "name", align: "start" },
        { text: this.$t("price"), value: "price", align: "right" },
        { text: this.$t("quantity"), value: "quantity", align: "right" },
        {
          text:
            this.$t("total") + " (" + this.$store.state.restaurant !== null &&
            this.$store.state.restaurant.settings
              ? this.$store.state.restaurant.settings.price
              : "" + ")",
          value: "qty",
          align: "right",
        },
      ];
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  watch: {
    "filters.dates": {
      handler() {
        this.loadNonContract();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
